export enum AdyenAcquirerDataEnum {
  TenderOption = 'tenderOption'
}
